import React from 'react';
import masterSlideLoader from '../utilities/masterSlideLoader';

//splitviewの開閉を管理する
export default class MasterSlideView extends React.Component {
  constructor(props) {
    super(props);

    //呼び出されたスライドのクラス名をステートに持つ
    this.state = {
      component: null,
      componentState: {},
    };

    //スライド呼び出し
    masterSlideLoader.setView = (component, componentState) => {
      this.setState({
        component,
        componentState,
      });
    };
  }

  componentDidMount() {
    if (this.props.url) {
      const url = this.props.url.split(':');
      masterSlideLoader.show(url[0], { state: { id: url[1] || 1 } });
    }
  }

  render() {
    const viewshow = () => {
      return this.state.component ? 'master-slide-view show' : 'modal';
    };
    return (
      <div
        className={viewshow()}
        style={{ backgroundColor: 'white', zIndex: 9999 }}
      >
        {!this.state.component ? (
          <div />
        ) : (
          <this.state.component view={this.state.componentState} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/masterSlideView.js